export default "__VITE_ASSET__o9Y8gNFm__"